import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, To, useSearchParams, createSearchParams } from "react-router-dom";
import { default as userService } from "@/services/user";
import { ChangePasswordError } from "@/types/models/services";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";

const usePassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const Settings = useSettingsContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [errorCode, setErrorCode] = useState<ChangePasswordError>();

  // TODO: Merge with the one in AuthenticationProvider in a new hook
  const handleRedirectLogIn = () => {
    const {
      redirectPath, pathParams, ...restSearchParams
    } = Object.fromEntries(searchParams);

    if (redirectPath) {
      navigate({
        pathname: t(
          redirectPath, 
          pathParams ? JSON.parse(pathParams) : {}
        ) as string,
        search: createSearchParams(restSearchParams).toString()
      });
    } else {
      navigate(t(`common:url.${Settings.homepage ?? "invoices"}`));
    }
  }

  const changePasswordAndRedirect = ({
    currentPassword,
    newPassword
  }: Parameters<typeof userService.changePassword>[0] & {
    redirect?: To | number;
  }) => {

    setIsLoading(true);
    userService.changePassword({ currentPassword, newPassword })
      .then(res => {
        handleRedirectLogIn();
      })
      .catch(err => {
        setErrorCode({
          error: err,
          type: err?.status_code === 403 ? "invalidPassword" : "generic"
        });
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const cancelChangePasswordAndRedirect = () => {
    handleRedirectLogIn();
  }

  return {
    changePasswordAndRedirect,
    cancelChangePasswordAndRedirect,
    isLoading,
    errorCode
  }
}

export default usePassword;